
import Vue from "vue"

import Button from "@/components/ui/Button.vue"
import BackToLogin from "@/views/Auth/components/BackToLogin.vue"

export default Vue.extend({
  name: "RestorePasswordForm",

  components: {
    Button,
    BackToLogin,
  },

  props: {
    // Письмо отправляется синхронно 1–5 с: пока идёт запрос, кнопка заблокирована,
    // иначе двойной клик шлёт два письма и рабочей остаётся только ссылка из последнего
    loading: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      form: this.$form.createForm(this, {name: "restore-password"}),
    }
  },

  methods: {
    handleSubmit(e: any) {
      e.preventDefault()
      if (this.loading) return

      const email = (this.form.getFieldValue("email") || "").trim()
      if (!email) return
      this.$emit("restore", {email})
    },

    emailChange(e: any) {
      this.form.setFieldsValue({
        email: e.target.value,
      })
      this.$emit("clear-error")
    },

    hasErrors(fieldsError: any) {
      return Object.keys(fieldsError).some((field) => fieldsError[field])
    },
  },
})
